export default __webpack_public_path__ + "static/media/rocket_anim_59.76f7bf99.png";